import React from 'react'
import { IconButton } from '@material-ui/core'
import { MoreVert, DragIndicator } from '@material-ui/icons'
import EntityTypeIcon from 'utils/EntityTypeIcon'
import Stats from 'components/TasksPage/Stats'

export default ({ task, width, style }) => {
  console.log(width)
  return (
    <div
      style={{
        backgroundColor: '#d6e6f8',
        borderRadius: 20,
        border: '2px solid #494769',
        height: 67,
        marginBottom: 10,
        padding: 10,
        position: 'relative',
        marginTop: 10,
        opacity: '0.7',
        width,
        ...style,
        transform: 'translate(0, 0)',
      }}
    >
      <div
        style={{
          position: 'absolute',
          top: 19,
          left: 7,
          cursor: 'grab',
        }}
      >
        <DragIndicator style={{ fill: 'rgba(0, 0, 0, 0.24)' }} />
      </div>
      <EntityTypeIcon
        entityType="task"
        entityID={task.task_type_id}
        style={{
          fill: '#494769',
          position: 'absolute',
          left: '29px',
          top: '12px',
          width: '37px',
          height: '37px',
        }}
      />
      <div
        style={{
          marginLeft: 60,
          color: '#494769',
          marginTop: task.sms_stats || task.email_stats ? 0 : 11,
          display: 'table',
          tableLayout: 'fixed',
          whiteSpace: 'nowrap',
          width: 'calc(100% - 102px)',
        }}
      >
        <span
          style={{
            display: 'table-cell',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            userSelect: 'none',
            cursor: 'default',
          }}
        >
          {task.name}
        </span>
      </div>
      <div style={{ marginLeft: 60 }}>
        <Stats task={task} />
      </div>
      <IconButton
        disableRipple
        disableTouchRipple
        disabled
        style={{ position: 'absolute', right: 4, top: 7 }}
      >
        <MoreVert />
      </IconButton>
    </div>
  )
}
